import _ from 'lodash';
import { connect } from 'react-redux';
import React, { useEffect } from 'react';

import { Actions } from '../../store/actions/organisationActions';
import OrganisationMetricRow from './OrganisationMetricRow';
import { checkReportingYearEnd } from '../utils/GlobalFunctions';

import { Info } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardFooter, CardTitle } from '../ui/card';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../ui/table';

const OrganisationMetrics = ({
  list,
  orgMetrics,
  addOrganisationMetric,
  orgDetails,
  getOrganisationMetrics,
  branding,
  addOrgMetricIssue,
}) => {
  const { primaryColor, tooltipBackground, tooltipText } = branding.colors;

  useEffect(() => {
    getOrganisationMetrics();
  }, [orgDetails.industry, getOrganisationMetrics]);

  return (
    <Card className='border rounded-md'>
      <CardHeader className='flex flex-row items-center justify-between pb-4'>
        <CardTitle className='text-xl font-semibold uppercase'>Revenue and Productivity Data</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow className='text-nowrap'>
              <TableHead>Reporting Period</TableHead>
              <TableHead>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <span>
                      Revenue <Info size={14} strokeWidth={1.5} className='cursor-pointer ml-1 text-primary inline' />
                    </span>
                  </TooltipTrigger>
                  <TooltipContent>Your Revenue for the indicated period.</TooltipContent>
                </Tooltip>
              </TableHead>
              {orgMetrics?.metric1 && orgMetrics?.metric1?.name !== 'revenue' && (
                <TableHead>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <span>
                        {orgMetrics.metric1?.name} <Info size={14} strokeWidth={1.5} className='cursor-pointer ml-1 text-primary inline' />
                      </span>
                    </TooltipTrigger>
                    <TooltipContent>{orgMetrics.metric1?.description}</TooltipContent>
                  </Tooltip>
                </TableHead>
              )}
              {orgMetrics?.metric2 && orgMetrics?.metric2?.name !== 'revenue' && (
                <TableHead>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <span>
                        {orgMetrics.metric2?.name} <Info size={14} strokeWidth={1.5} className='cursor-pointer ml-1 text-primary inline' />
                      </span>
                    </TooltipTrigger>
                    <TooltipContent>{orgMetrics.metric2?.description}</TooltipContent>
                  </Tooltip>
                </TableHead>
              )}
              {orgMetrics?.metric3 && orgMetrics?.metric3?.name !== 'revenue' && (
                <TableHead>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <span>
                        {orgMetrics.metric3?.name} <Info size={14} strokeWidth={1.5} className='cursor-pointer ml-1 text-primary inline' />
                      </span>
                    </TooltipTrigger>
                    <TooltipContent>{orgMetrics.metric3?.description}</TooltipContent>
                  </Tooltip>
                </TableHead>
              )}
              <TableHead className='text-right'></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {list && Array.isArray(list) && list.length > 0 ? (
              list.map((metric, index) => (
                <OrganisationMetricRow key={index} metric={metric} orgMetrics={orgMetrics} list={list} />
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} className='text-center'>
                  No metrics available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
      {list && Array.isArray(list) && (
        <CardFooter className='flex justify-start pt-2 pb-4'>
          <Button
            className='font-semibold text-base bg-secondary text-secondary-foreground hover:text-primary-foreground'
            onClick={() => !addOrgMetricIssue && addOrganisationMetric()}
            disabled={addOrgMetricIssue}>
            {addOrgMetricIssue ? 'Set reporting year end before adding a metric' : 'Add a Metric'}
          </Button>
        </CardFooter>
      )}
    </Card>
  );
};

const mapStateToProps = (state) => {
  const orgDetails = state.organisation?.details;
  const addOrgMetricIssue = checkReportingYearEnd(orgDetails);
  const metrics = state.metric?.list;
  const orgIndustry = _.find(state.organisation.industries, { id: orgDetails.industry });

  const orgMetrics = {};

  if (metrics && orgDetails) {
    if (orgIndustry?.intensityRatioMetric1ID) {
      const metric = metrics.find((item) => item.id === orgIndustry.intensityRatioMetric1ID);
      orgMetrics.metric1 = metric;
    }

    if (orgIndustry?.intensityRatioMetric2ID) {
      const metric = metrics.find((item) => item.id === orgIndustry.intensityRatioMetric2ID);
      orgMetrics.metric2 = metric;
    }

    if (orgIndustry?.intensityRatioMetric3ID) {
      const metric = metrics.find((item) => item.id === orgIndustry.intensityRatioMetric3ID);
      orgMetrics.metric3 = metric;
    }
  }

  let list =
    state.organisation?.metrics &&
    Array.isArray(state.organisation?.metrics) &&
    state.organisation?.metrics?.filter((item) => item?.organisationId == state.currentOrganisation);

  return {
    branding: state.branding,
    list: list,
    orgMetrics,
    orgDetails,
    addOrgMetricIssue,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getOrganisationMetrics: () => dispatch(Actions.getOrganisationMetrics()),
  addOrganisationMetric: () => dispatch(Actions.addOrganisationMetric()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganisationMetrics);
